import React from 'react';
import {  Container, Row } from 'react-bootstrap';
import './Projects.css'
import Menubar from '../Shared/MenuBar/Menubar';
import { AllProjects } from '../Fakedata/AllProjects';
import SingleProjects from './SingleProjects';
import SinglePortfolio from '../Home/Portfolio/SinglePortfolio';
import Footer from '../Shared/Footer/Footer';


const Projects = () => {
    return (
        <>
        <Menubar/>
        <Container className='py-5'>
            <div className='section-header my-4'>
            <h3 >All of my Projects </h3>
            
            </div>
            <Row>
                {
                    AllProjects.map(ap=><SinglePortfolio project={ap}/>)
                }
            </Row>
            
        </Container>
        <Footer/>
        </>
    );
};

export default Projects;